import { render, staticRenderFns } from "./LoyaltyCertTypeAddComponent.vue?vue&type=template&id=6d647cf3&scoped=true"
import script from "./LoyaltyCertTypeAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCertTypeAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d647cf3",
  null
  
)

export default component.exports